import script from "./LedgerTransactionForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./LedgerTransactionForm.vue?vue&type=script&setup=true&lang=ts"

import "./LedgerTransactionForm.vue?vue&type=style&index=0&id=918664be&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-918664be"]])

export default __exports__